import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { environment } from "../../../environments/environment";
import { JsonPipe, NgIf } from "@angular/common";

@Component({
  selector: 'snapmatic-progress',
  standalone: true,
  imports: [
    JsonPipe,
    NgIf
  ],
  templateUrl: './progress.component.html'
})
export class ProgressComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild('valueBox_percent') valueBox_percent!: ElementRef;
  @ViewChild('valueBox_stage') valueBox_stage!: ElementRef;
  @ViewChild('loader_bar') loader_bar!: ElementRef;
  @ViewChild('loader_barmask') loader_barmask!: ElementRef;

  @Input() status: string = '';
  @Input() position: number = 0;

  private index: number = -1;
  public percent: number = 0;
  public stage: string | undefined;
  public messages: Array<string> = [];

  protected readonly stages: Record<string, any> = environment.stages;
  protected readonly distribution: Record<string, number> = environment.distribution;
  private timeout: any;
  private timeout2: any;
  private interval: any;

  private nextStep: undefined | number;

  constructor(
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // console.log('ngAfterViewInit()', this.stage, this.percent, this.messages)
    if (this.percent) {
      // console.log('init update')
      this.updateLoaderUi();
      this.updateStageUi(this.messages);
      this.updatePercentUi(this.percent);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes', changes);
    if(changes['status']) {
      // console.log('changes', changes);
      clearTimeout(this.timeout2);
      clearInterval(this.interval);
      this.calculate(changes['status'].currentValue.toLowerCase());

      if (changes['status'].currentValue.toLowerCase().indexOf('error') !== -1) {
        console.log('error detected');
        setTimeout(() => {
          window.location.reload();
        }, 30 * 1000);
        return;
      }

      if(changes['status'].currentValue.toLowerCase().indexOf('generation') !== -1) { // only creep if in generation
        this.timeout2 = setTimeout(() => {
          this.interval = setInterval(() => {
            if (this.percent < 100) {

              if (this.nextStep && this.percent === (this.nextStep - 1)) { //something here to determine if reached next step, if so stop the percentage increase
                // console.log('stopping at nextStep', this.nextStep);
                clearInterval(this.interval);
                clearTimeout(this.timeout2);
                this.nextStep = undefined;
              }

              this.percent++;
              this.updatePercentUi(this.percent);
              this.updateStageUi(this.messages);
              this.updateLoaderUi();
              // console.log('ngOnChanges counter', changes['status'].currentValue, this.percent);
            } else {
              clearInterval(this.interval);
              if (this.percent > 99) {
                // it should not go to 100%. So refresh the page
                window.location.reload();
              }
            }
          }, 3000);
        }, 1000);
      }
    }
  }

  private calculate(current: string): void {
    // console.log(Object.keys(this.stages))
    for (let stage of Object.keys(this.stages)) {
      // console.log('checking', stage, current);
      if (current.indexOf(stage) === 0) {
        // console.log('includes', stage, current);

        let index = Object.keys(this.stages).indexOf(stage);

        // console.log('new index, old index', index, this.index);

        if (index > this.index) { // only progress forward
          this.index = index;
          this.stage = stage;
          this.messages = typeof this.stages[stage] === 'string' ? [ this.stages[stage] ] : this.stages[stage];
          // console.log('messages', this.messages);

        }

        if (current != stage) { // if current includes percentage information as a suffix, update percentage
          const regexp = RegExp(stage + '_(\\d+)_(\\d+)', 'gi')
          let result = regexp.exec(current);
          // console.log("RegExp result", result, current, stage);
          if (result) {
            let modifier = parseInt(result[1], 10) * 100 / parseInt(result[2], 10);
            let nextStep = (parseInt(result[1], 10) + 1) * 100 / parseInt(result[2], 10);
            // console.log('cccc', stage, modifier);
            this.calculatePercent(stage, modifier, nextStep);

            this.updatePercentUi(this.percent);
            this.updateStageUi(this.messages);
            this.updateLoaderUi();

          }
        } else {
          this.calculatePercent(stage);

          this.updatePercentUi(this.percent);
          this.updateStageUi(this.messages);
          this.updateLoaderUi();
        }
      }
    }
  }

  private calculatePercent(stage: string, modifier = 0, nextStep = 0): void {
    // console.log('XXX');
    // console.log('calculatePercent', stage, modifier, this.index);

    if(stage.indexOf('error') !== -1) {
      this.percent = 0;
      return;
    }

    let candidate = 0;

    // for every previous stage, add the percentage to the candidate
    for (const [ index, [ key, value ] ] of Object.entries(Object.entries(this.distribution))) {
      // console.log(`${index}: ${key} = ${value}`);
      if (parseInt(index, 10) < this.index) {
        candidate += value;
      }
    }

    // console.log('modifier', modifier, 'candidate', candidate, 'this.nextStep', this.nextStep, 'this.dis[stage]', this.distribution[stage]);

    if(nextStep > 0) {
      // console.log('calc:', candidate, nextStep / 100, this.distribution[stage], (nextStep / 100) * this.distribution[stage]);
      this.nextStep = Math.floor(candidate + (nextStep / 100) * this.distribution[stage]);
      // console.log('nextStep', this.nextStep);
    }

    // if modifier is set, add the percentage of the current stage multiplied by the modifier
    if (modifier > 0) {
      candidate += (modifier / 100) * this.distribution[stage];
    }
    // console.log('candidate', candidate, this.percent)
    if (candidate > this.percent) {
      this.percent = Math.floor(candidate);
    }
  }

  pickMessage(messages: Array<string>) {
    if (messages.length > 0) {
      return messages[Math.floor(Math.random() * messages.length)];
    } else {
      return '';
    }
  }

  updatePercentUi(new_percent: number) {

    if (this.valueBox_percent) {
      let currPercent = parseInt(this.valueBox_percent.nativeElement.innerHTML) || 0; //what it was

      let diff = new_percent - currPercent; // how much we need to add
      let timer = 1000;//2500;
      let per_step = timer / diff;

      // console.log('updatePercent', currPercent, new_percent);

      if (currPercent < new_percent) {

        currPercent++;
        this.valueBox_percent.nativeElement.innerHTML = currPercent + "%"

        this.timeout = setTimeout(() => {

          this.updatePercentUi(new_percent)

        }, per_step)

      }
    }

  }

  updateLoaderUi() {
    if (this.loader_bar) {
      let r = 98;
      let c = Math.PI * (r * 2);
      let pct = ((100 - this.percent) / 100) * c;

      // console.log('pct', pct, this.percent);

      this.renderer.setStyle(this.loader_bar.nativeElement, "strokeDashoffset", pct);
      this.renderer.setStyle(this.loader_barmask.nativeElement, "strokeDashoffset", pct);
    }
  }

  updateStageUi(candidate : Array<string>){

    if( ! this.valueBox_stage) return;

    // console.log('updateStageView', this.valueBox_stage.nativeElement.innerHTML)

    let new_stage = '';

    var currStage = this.valueBox_stage.nativeElement.innerHTML; //what it was

    if(candidate.length == 1 && currStage == candidate[0]) return;

    let substage_no = Math.floor(Math.random() * candidate.length);
    new_stage = candidate[Math.min(candidate.length, substage_no)] // select this substage but dont go above the amount we have ( final stage is not 100 )

    // console.log('new_stage', new_stage, currStage);

    var view_stage = new_stage; //this.view_stage // what we're going to show
    var typed_stage = currStage; //this.typed_stage // what we've typed so far
    var display_element = this.valueBox_stage.nativeElement;

    if (currStage.length > 0) {
      deleteStage();
    } else {
      typeStage(0);
    }

    function typeStage(i: number) {

      // presuming we are at 0
      if (typed_stage.length < view_stage.length) {

        typed_stage += view_stage[i];
        display_element.innerHTML = typed_stage;
        i++;

        setTimeout(() => {
          typeStage(i)
        }, 60)
      }
    }

    function deleteStage() {
      if (typed_stage.length > 0) {
        // remove a character from typed_stage
        typed_stage = typed_stage.slice(0, -1)
        display_element.innerHTML = typed_stage

        setTimeout(() => {
          deleteStage()
        }, 20)
      } else {
        typeStage(0)
      }
    }
  }
}
